import { returnsTeamDiscountByWeightSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getTeamOverrideDiscountTables = {
  name: "getTeamOverrideDiscountTables" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    discountTables: z.array(returnsTeamDiscountByWeightSchema),
  }),
};
